import React from "react";
import  "./HeaderSmall.css"
import { Image } from "semantic-ui-react";
import logoIeepo from "../../Images/logoIeepo.png"
import logoOax from "../../Images/logoOax.png"
import ENEPO from "../../Images/ENEPO.png"

 function HeaderSmall(props) {
    const { btTitulo} = props;

  return (
    <div className="rectangulo">
      <div className="imagenes">
           <Image src={logoOax} className="imaOaxaca" />
          <Image src={logoIeepo} className="imaIeepo"/>
          <Image src={ENEPO} className="imaenepo"/>
        </div>
        <h1 className="nombreEscuelasmall">
          UNIDAD DE EDUCACIÓN NORMAL Y FORMACIÓN DE DOCENTES <br/>
        “ESCUELA NORMAL DE EDUCACIÓN PREESCOLAR”<br/>
        CLAVE:20DNL0004O
        </h1>
        <h1 className="tituloin">{btTitulo}</h1>
    </div>
  );
}
export default HeaderSmall;